import Button from "@edaz/edazkit/Button";
import HeaderRow from "@edaz/edazkit/HeaderRow";
import type { ViewComponent } from "@frui.ts/views";
import { registerView } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import Tabs from "../../common/tabs";
import React from "react";
import OutgoingPaymentsViewModel from "viewModels/finance/outgoingPayments/outgoingPaymentsViewModel";

const OutgoingPaymentsView: ViewComponent<OutgoingPaymentsViewModel> = observer(({ vm }) => (
  <>
    <HeaderRow title={vm.name} level={3} className="mb-4">
      {vm.activeChild?.allowReportDownload && (
        <Button
          size="sm"
          variant="primary"
          className="rounded"
          onClick={vm.activeChild.download}
          disabled={vm.activeChild.busyWatcher.isBusy || vm.activeChild.downloadBusyWatcher.isBusy}>
          <>
            {vm.activeChild.downloadBusyWatcher.isBusy && <div className="spinner-border spinner-border-xs mr-2" role="status" />}
            {vm.translate("downloadReport")}
          </>
        </Button>
      )}
    </HeaderRow>
    <Tabs vm={vm} />
  </>
));

registerView(OutgoingPaymentsView, OutgoingPaymentsViewModel);
